'use client';
var defaultStylesParams = {
    color: "primary",
    transitionDuration: 200,
    variant: "default",
    radius: 56,
    size: "xxs1"
};

export { defaultStylesParams };
